import { render, staticRenderFns } from "./GetSalarySlipButton.vue?vue&type=template&id=2f7a9d5e&scoped=true&lang=pug&"
import script from "./GetSalarySlipButton.vue?vue&type=script&lang=js&"
export * from "./GetSalarySlipButton.vue?vue&type=script&lang=js&"
import style0 from "./GetSalarySlipButton.vue?vue&type=style&index=0&id=2f7a9d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a9d5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
